// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6b8af9ed","239":"dddb3ce5","455":"11fa2b43"}[chunkId] + ".chunk.js";
};